import { PersonaConfig } from '../types';

export const stargazingPersona: PersonaConfig = {
  id: 'stargazing',
  name: 'Star Gazing',
  icon: '🔭',
  description: 'Dark sky scores, moon phase cycles, astronomical twilight, and Milky Way AR.',
  accentColor: '#6366f1',
  timeline: {
    showSolarLunarTrack: true,
    showMoonPhaseBadges: true,
  },
  forecastPanel: {
    temperaturePlotMode: 'single_location_only',
    hideAstronomicalEvents: false,
    showMilkyWayArButton: true,
  },
  mapDefaults: {
    recommendedPrimaryLayer: undefined,
    enabledOverlays: [],
  },
};
